import * as ActionType from './types'
import axios from 'axios'
import { hideAPIErrorInfo, showAPIErrorInfo } from './errorActions'
import { getDetailsData } from 'settings/xhr/axiosRequests'
import { getApiEndpointByEntrypoint } from 'settings/app/helpers'

/**
 * performe details request
 * => /krankenhaus/:id?type=OPS&key=5-55&zip=01159&city=Dresden
 * => /arzt/:id?zip=01159&city=Dresden
 */
export const fetchDetails =
  (entryPoint, id, queryParams = '') =>
  async (dispatch, getState) => {
    if (!!getState().apiError) {
      dispatch(hideAPIErrorInfo())
    }
    const endpoint = getApiEndpointByEntrypoint(entryPoint)

    await getDetailsData({ endpoint, id, queryParams })
      .then((data) => {
        dispatch({
          type: ActionType.FETCH_DETAILS_COMPLETE,
          payload: data,
        })
      })
      .catch((error) => {
        // handle error
        console.error('fetch details error: ', error)
        // only show error if request was not canceled
        if (!axios.isCancel(error)) {
          dispatch(showAPIErrorInfo())
        }
      })
  }

export const clearDetails = () => ({
  type: ActionType.FETCH_DETAILS_COMPLETE,
  payload: null,
})
